import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'

import {
    PropertiesController,
    usePropertiesController,
} from '../../SidePanel/RightPanel/PropertiesController.jsx'

import SelectUvTemplate from './SelectUvTemplate.jsx'

export default function PropertiesControllerUt({
    className,
    style,
    ...props
}) {
    const [values, update] = useProperties()
    const {layoutPicId, layoutTypeId, utName} = values
    const p = usePropertiesController({prop: 'layoutPicId'})
    const handleChange = ({utId, utName}) => update({layoutPicId: utId, utName})

    return (
        <PropertiesController
            className={className}
            style={style}
            hidden={p.hidden}
            label={p.label}
            required={p.required}
        >
            <SelectUvTemplate
                disabled={p.disabled}
                readOnly={p.readOnly}
                value={{layoutTypeId, utId: layoutPicId, utName}}
                onChange={handleChange}
                {...props}
            />
        </PropertiesController>
    )
}
